import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

const getToken = () => {
  const token = localStorage.getItem("token");
  try {
    return token ? JSON.parse(token) : null;
  } catch (err) {
    return null;
  }
};

function connectToSocket() {
  const socket = openSocket(getBackendUrl(), {
    // Long-polling entrega o áudio da ligação em rajadas e o uplink é
    // descartado; websocket primeiro, polling só como último recurso.
    transports: ["websocket", "polling"],
    query: {
      token: getToken(),
    },
  });

  const refreshQueryToken = () => {
    const token = getToken();
    if (!token) return false;
    socket.io.opts.query = { token };
    return true;
  };

  socket.io.on("reconnect_attempt", refreshQueryToken);

  // O backend derruba a conexão quando o JWT expira; após a renovação do token
  // é preciso reconectar manualmente, pois o cliente não refaz sozinho.
  let retrying = false;
  let rejectedToken = null;

  socket.on("disconnect", reason => {
    if (reason !== "io server disconnect") return;

    // Reconectar com o mesmo token expirado só gera um laço de handshakes que
    // consome o event loop do backend indefinidamente.
    rejectedToken = getToken();
    if (retrying) return;
    retrying = true;

    let attempts = 0;
    const retry = () => {
      if (socket.connected || attempts >= 5) {
        retrying = false;
        return;
      }

      const token = getToken();
      if (token && token !== rejectedToken && refreshQueryToken()) {
        attempts += 1;
        socket.connect();
      }

      setTimeout(retry, 3000 * (attempts + 1));
    };

    setTimeout(retry, 1500);
  });

  return socket;
}

export default connectToSocket;
